import {
  JournalEntriesState,
  JournalEntriesAction,
  JournalEntriesActionType,
  journalEntriesInitialState
} from '../../../interfaceTypes/journalEntries'

export const journalEntriesReducer = (
  state: JournalEntriesState,
  action: JournalEntriesAction
): JournalEntriesState => {
  switch (action.type) {
    case JournalEntriesActionType.SET_JOURNAL_ENTRIES:
      return {
        ...state,
        journalEntries: action.journalEntries
      }

    case JournalEntriesActionType.SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.filters }
      }

    case JournalEntriesActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }

    case JournalEntriesActionType.RESET_FILTERS:
      return {
        ...state,
        filters: {}
      }

    default:
      return state
  }
}

export { journalEntriesInitialState }
